import { parseInboundPayload } from '../inbound';
import { createArrayWithBracesParser, encodedStringParser } from '../inboundParsers';
import { splitWithBraces, trimBraces } from '../inboundUtils';
import { playerIdNameParser } from './utils/playerInboundUtils';
export const NEWEST_PLAYERS_LIST_PAYLOAD_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [{ name: 'newestPlayers', parser: createArrayWithBracesParser(newestPlayerParser) }]
};
function newestPlayerParser(str) {
    const inboundParts = splitWithBraces(trimBraces(str));
    return parseInboundPayload(inboundParts, newestPlayerPartDefinitions);
}
const newestPlayerPartDefinitions = [
    { name: 'playerIdName', parser: playerIdNameParser },
    { name: 'signUpTimeStr', parser: encodedStringParser }
];
